import type { ChatbotTheme } from "../types";

export const defaultTheme: Required<ChatbotTheme> = {
  primaryColor: "#1a1a2e",
  accentColor: "#c9a84c",
  headerBackground: "#1a1a2e",
  headerTextColor: "#f5f0e8",
  userBubbleBackground: "#1a1a2e",
  userBubbleTextColor: "#f5f0e8",
  assistantBubbleBackground: "#f5f0e8",
  assistantBubbleTextColor: "#1a1a2e",
  inputBackground: "#ffffff",
  inputBorderColor: "#e8e0d0",
  inputTextColor: "#1a1a2e",
  fontSize: "14px",
  borderRadius: "16px",
  fontFamily: "'DM Sans', ui-sans-serif, system-ui, sans-serif",
  displayFontFamily: "'DM Serif Display', Georgia, serif",
  backdropBlur: "0px",
  widgetBackground: "#ffffff",
  widgetBorderColor: "#e8e0d0",
  shadowIntensity: "medium",
};

export function createThemeStyles(theme: ChatbotTheme = {}): string {
  const t = { ...defaultTheme, ...theme };

  const shadows: Record<string, string> = {
    none: "none",
    low: "0 4px 16px rgba(0,0,0,0.06)",
    medium: "0 8px 40px rgba(26,26,46,0.14), 0 2px 8px rgba(26,26,46,0.06)",
    high: "0 20px 60px rgba(26,26,46,0.22), 0 4px 16px rgba(26,26,46,0.10)",
  };

  const shadow = shadows[t.shadowIntensity] ?? shadows.medium;

  return `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,400&family=DM+Serif+Display:ital@0;1&display=swap');

    :host {
      --ac-primary:        ${t.primaryColor};
      --ac-accent:         ${t.accentColor};
      --ac-header-bg:      ${t.headerBackground};
      --ac-header-text:    ${t.headerTextColor};
      --ac-user-bg:        ${t.userBubbleBackground};
      --ac-user-text:      ${t.userBubbleTextColor};
      --ac-bot-bg:         ${t.assistantBubbleBackground};
      --ac-bot-text:       ${t.assistantBubbleTextColor};
      --ac-input-bg:       ${t.inputBackground};
      --ac-input-border:   ${t.inputBorderColor};
      --ac-input-text:     ${t.inputTextColor};
      --ac-font-size:      ${t.fontSize};
      --ac-radius:         ${t.borderRadius};
      --ac-font:           ${t.fontFamily};
      --ac-display-font:   ${t.displayFontFamily};
      --ac-blur:           ${t.backdropBlur};
      --ac-widget-bg:      ${t.widgetBackground};
      --ac-widget-border:  ${t.widgetBorderColor};
      --ac-shadow:         ${shadow};

      /* Derived tokens */
      --ac-radius-sm: calc(var(--ac-radius) * 0.55);
      --ac-radius-xs: calc(var(--ac-radius) * 0.3);
    }
  `;
}
